<template>
    <v-container >
        <v-row justify="center">
            <v-col cols="12" md="6" >
                <base-material-card  color="primary" light max-width="100%"  class="px-5 py-3">
                    <template #heading>
                        <h1 class="display-2 font-weight-bold mb-2">
                            Login
                        </h1>
                    </template>
                    <v-card-text>
                        <v-container class="px-5">
                            <v-form ref="form" lazy-validation v-model="valid">
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="email"
                                            label="E-mail"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="password"
                                            type="password"
                                            label="Password"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>

                            <v-card-actions>
                                <v-alert
                                    class="w-100"
                                    v-model="alert"
                                    dismissible
                                    color="error"
                                    border="left"
                                    elevation="2"
                                    colored-border>
                                    {{responseError}}
                                </v-alert>
                            </v-card-actions>
                            <v-card-actions>
                                <v-btn color="primary" @click="submit">Login</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn  to="/password/email" link text x-small >Password dimenticata ?</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Login",
        data: () => ({
            valid: false,
            email: "",
            password: "",
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 10 || 'Name must be less than 10 characters',
            ],

            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            alert:false,
            responseError:""
        }),
        methods:{
            submit () {

                if (this.$refs.form.validate()) {
                    this.$store.dispatch('login',{
                        email:this.email,
                        password:this.password
                    }).then((response)=>{
                        this.$router.replace('/')
                    }).catch((error)=>{
                        this.responseError = "Dati di accesso non validi"
                        this.alert = true;
                        }

                    );
                }
            },
        }
    }
</script>

<style scoped>

</style>
